import React from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

import Money from '../../../image/MoneyImage.png';

import LoadingAnimation from '../../../Animation/NewLoading.json';
import FrequencyBox from './FrequncyBox';

export default function DurationBox(props) {
  const {
    isOpenPartnerGymSales,
    calcDateText,
    priceAvg,
    durationAvg,
    durationMembers,
    frequencyData,
    isFrequencyLoading
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();


  // ACV 산출 //
  function calcACV() {
    // (월 평균 매출 / 장기 회원 수) * 평균 회원 지속일 //
    if (durationAvg === 0 || priceAvg === 0 || durationMembers.length === 0) return '0' + t('statistics.won');
    else return Math.round(durationAvg * (priceAvg / durationMembers.length)).toLocaleString('ko-KR') + t('statistics.won');
  }

  return (
    <TopLevelWrapper $isDark={isDark}>
      <InfoBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{calcDateText() + ' Lifetime Value [LTV]'}</Text>
        {
          isOpenPartnerGymSales ?
            <InnerInfoBox>
              <TotalACVBox>
                <ImageBoxWrapper gap={9}>
                  <MoneyImage src={Money} />
                  <ColorTextBox backgroundColor='#FF8B48'>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subBackground} cursor='default'>{t('statistics.duration.monthlyAvgSales')}</Text>
                    <PriceAvgWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='default'>{': ' + priceAvg.toLocaleString('ko-KR')}</Text>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={10} color={theme.subBackground} cursor='default'>{t('statistics.won')}</Text>
                    </PriceAvgWrapper>
                  </ColorTextBox>
                </ImageBoxWrapper>
                <LTVBoxWrapper>
                  <LTVBox>
                    <LTVTitleWrapper>
                      <Text fontFamily='NotoSansKR-Bold' fontSize={20} color={theme.background} cursor='default'>LTV</Text>
                      <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.background} cursor='default'>{t('statistics.duration.ltvDesc')}</Text>
                    </LTVTitleWrapper>
                    <LTVCalculationWrapper>
                      <CalcInfoBox>
                        <ColumnWrapper>
                          <Text fontFamily='NotoSansKR-Bold' fontSize={18} color={theme.subBackground} cursor='default'>{priceAvg.toLocaleString('ko-KR')}</Text>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subBackground} cursor='default'>{t('statistics.duration.monthlyAvgSales')}</Text>
                        </ColumnWrapper>
                        <CalcDivisionLine />
                        <ColumnWrapper>
                          <Text fontFamily='NotoSansKR-Bold' fontSize={18} color={theme.subBackground} cursor='default'>{durationMembers.length.toLocaleString('ko-KR')}</Text>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subBackground} cursor='default'>{t('statistics.duration.validMembers')}</Text>
                        </ColumnWrapper>
                      </CalcInfoBox>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={20} color={theme.subBackground} cursor='default'>X</Text>
                      <CalcInfoBox>
                        <ColumnWrapper>
                          <Text fontFamily='NotoSansKR-Bold' fontSize={18} color={theme.subBackground} cursor='default'>{durationAvg.toLocaleString('ko-KR')}</Text>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subBackground} cursor='default'>{t('statistics.duration.avgMembership')}</Text>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subBackground} cursor='default'>{t('statistics.duration.retentionDaysMonths')}</Text>
                        </ColumnWrapper>
                      </CalcInfoBox>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={20} color={theme.subBackground} cursor='default'>=</Text>
                      <LTVValueBox>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={18} color={theme.subBackground} cursor='default'>{calcACV()}</Text>
                      </LTVValueBox>
                    </LTVCalculationWrapper>
                  </LTVBox>
                  <LTVExplanationWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default' style={{ whiteSpace: 'pre-line' }}>{t('statistics.duration.ltvExplain1')}</Text>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{'· ' + t('statistics.duration.ltvExplain2')}</Text>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{'· ' + t('statistics.duration.ltvExplain3')}</Text>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default' style={{ whiteSpace: 'pre-line', marginTop: '4px' }}>{t('statistics.duration.ltvExplain4')}</Text>
                  </LTVExplanationWrapper>
                </LTVBoxWrapper>
              </TotalACVBox>
            </InnerInfoBox>
            :
            <InnerInfoBox>
              <NotOpenTextWrapper>
                <Text fontFamily='NotoSansKR-Bold' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivate')}</Text>
                <Text fontFamily='NotoSansKR-Regular' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivateDesc')}</Text>
              </NotOpenTextWrapper>
            </InnerInfoBox>
        }
      </InfoBox>
      <BoxDivisionLine />
      {
        isFrequencyLoading ?
          <InfoBox>
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
          </InfoBox>
          :
          <InfoBox>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{calcDateText() + ' ' + t('statistics.duration.classAttendance')}</Text>
            {
              isOpenPartnerGymSales ?
                <InnerInfoBox>
                  <ScrollWrapper>
                    {
                      frequencyData.map((data, index) => (
                        <ComponentWrapper key={'Frequency-' + index}>
                          <FrequencyBox data={data}/>
                        </ComponentWrapper>
                      ))
                    }
                  </ScrollWrapper>
                </InnerInfoBox>
                :
                <InnerInfoBox>
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivate')}</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivateDesc')}</Text>
                  </NotOpenTextWrapper>
                </InnerInfoBox>
            }
          </InfoBox>
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 38px;

  width: 1020px;
  // height: 472px;
  height: 520px;

  gap: 28px;

  border-radius: 30px;
  box-shadow: ${props => props.$isDark ? 'none' : '0 40px 50px rgba(240, 232, 227, 0.5)'};
  background-color: ${props => props.theme.subBackground};
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-conetent: flex-start;
  align-items: flex-start;

  width: 44.7%;
  // height: 426px;
  height: 474px;
`;

const InnerInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  // height: 364px;
  height: 410px;
`;

const TotalACVBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
  height: 364px;
`;

const AnimationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  z-index: 5;
  
  width: 100%;
  height: 364px;

  background-color: ${props => props.theme.subBackground};
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 160px;
  height: 160px;
`;

const LTVBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: cneter;
  align-items: center;

  margin-top: 10px;

  width: 100%;
`;

const LTVBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px;

  width: 392px;
  height: 178px;

  border-radius: 8px;
  background-color: ${props => props.theme.primary};
`;

const LTVTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const LTVCalculationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 30px;

  gap: 4px;
`;

const CalcInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 0px 10px;

  height: 105px;

  border-radius: 10px;
  background-color: ${props => props.theme.whiteAlpha20};
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const CalcDivisionLine = styled.div`
  margin: 2px 0px;

  width: 100%;
  height: 1px;

  border-radius: 2px;
  background-color: ${props => props.theme.subBackground};
`;

const LTVValueBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 152px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.whiteAlpha20};
`;

const LTVExplanationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 30px;

  width: 412px;

  gap: 2px;
`;

const LTVExplanationInnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: flex-start;
  align-items: flex-start;
`;
const BoxDivisionLine = styled.div`
  diplay: flex;
  flex-direction: row;

  width: 1px;
  height: 426px;

  background-color: ${props => props.theme.line};
`;

const ImageBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 24px;

  gap: ${props => props.gap}px;
`;

const DurationImage = styled.img`
  width: 52px;
  height: 52px;
`;

const MoneyImage = styled.img`
  width: 40px;
  height: 38px;
`;

const ColorTextBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 19px;
  margin-top: 9px;

  height: 28px;

  gap: 4px;

  border-radius: 8px;
  background-color: ${props => props.backgroundColor};
`;

const PriceAvgWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-end;
`;

const ScrollWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 28px;

  width: 100%;
  // height: 358px;
  height: 390px;

  gap: 18px;

  overflow-y: scroll;
  overflow-x: none;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
    border: 3px solid transparent;
    background-color: ${props => props.theme.scrollBar};
    border-radius: 200px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${props => props.theme.subBackground};
    border-radius: 200px;
  }
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const NotOpenTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;